<template>
    <div v-if="answer">
        <div v-if="answer.type === 'choice'">
            {{ answer.choice.label }}
        </div>
        <div v-if="answer.type === 'text'">
            {{ answer.text }}
        </div>
        <div v-if="answer.type === 'date'">
            {{ moment(answer.date).format('MM/DD/YYYY') }}
        </div>
        <div v-if="answer.type === 'boolean'">
            {{ answer.boolean ? 'Yes' : 'No' }}
        </div>
    </div>

</template>

<script>
import moment from 'moment'

export default {
    name: 'ResponseAnswer',
    props: ['answer'],
    methods: {
        moment: (...args) => moment(...args)
    }
}
</script>